module.exports = function() {
  return new Worker(__webpack_public_path__ + "4b7dafe21aff958df95c.worker.js");
};